import React, { FunctionComponent, useEffect, useState } from 'react'
import { getStoredBackendNotifications, isRunningInWebview } from '../../graphql-client/storedState'
import { BackendNotification } from '../../util/notifications/types'
import { RouteWrapper } from '../layout'
import { FullscreenModal } from '../ModalPage'
import BackendNotificationList from './BackendNotificationList'

const BackendNotificationModal: FunctionComponent = () => {
  const [notifications, setNotifications] = useState<BackendNotification[]>([])

  useEffect(() => {
    const handleStorage = (event?: Event) => {
      const storedNotifications = getStoredBackendNotifications()
      const isWebview = isRunningInWebview()
      console.log('storageEvent', event, storedNotifications)
      if (storedNotifications && !isWebview) {
        setNotifications(storedNotifications)
      } else {
        setNotifications([]);
      }
    }

    handleStorage()

    window.addEventListener('storage', handleStorage)
    window.addEventListener('backend-notifications-updated', handleStorage)
    return () => {
      window.removeEventListener('storage', handleStorage)
      window.removeEventListener('backend-notifications-updated', handleStorage)
    }
  }, [])

  return (
    <>
      {notifications.length > 0 && (
        <FullscreenModal onClose={() => {}} label="" showHeader={false}>
          <RouteWrapper />
          <BackendNotificationList notifications={notifications} />
        </FullscreenModal>
      )}
    </>
  )
}

export default BackendNotificationModal
